// features/exampleSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
//   data: {}, // Initial data, can be any structure
};

const usrerrbSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserToken: (state, action) => {
        return action.payload; // Update state with payload
    },
    removeUserToken: (state, action) => {
        return {};
    },
  },
});

export const { setUserToken, removeUserToken } = usrerrbSlice.actions;
export default usrerrbSlice.reducer;
